/* @flow */
import localConfig from './localConfig'
import commonConfig from '../common/config'

export const APP_NAME = require('../../package.json').name

export const APP_VERSION = process.env.appVersion || process.env.HEROKU_SLUG_COMMIT
export const IS_PRODUCTION = process.env.NODE_ENV === 'production'
export const APP_PORT = localConfig.port
export const APP_URL = localConfig.url

export const SENDGRID_API_KEY = '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'
export const TRANSLATE_API_KEY = 'trnsl.1.1.20190226T214959Z.d47c3b5bedbe44ec.6b075f7a1751c1888163e1f2670ba85224681723'
export const TRANSLATE_API = `https://translate.yandex.net/api/v1.5/tr.json/translate?key=${TRANSLATE_API_KEY}`

const config = {
  appName: APP_NAME,
  appVersion: APP_VERSION,
  env: localConfig.env || 'development',
  isProduction: IS_PRODUCTION,
  defaultLocale: 'en',
  locales: ['en', 'cs', 'sk'],
  resetValidTo: 24 * 60 * 60 * 1000, // platnost odkazu pro reset hesla
  mails: {
    invite: 'invite@vobo.io',
    support: 'support@vobo.io',
  },
}

let nconf = {}
const finalConfig = Object.assign(config, commonConfig, localConfig)
if (!process.env.IS_BROWSER) {
  nconf = require('nconf')

  nconf.env('__')
  nconf.defaults(finalConfig)
} else {
  nconf.get = () => finalConfig
}
export default nconf.get()



// WEBPACK FOOTER //
// ./src/server/config.js